module.exports = __webpack_public_path__ + "img/A-1529822-1617541915-3955.jpeg.bb004815.jpg";